// removed by extract-text-webpack-plugin
module.exports = {"Label":"_176rh","LabelActive":"_3q-Ec"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/InputLabel/InputLabel.scss
// module id = 472
// module chunks = 0